import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from '../utils';

const StarRatingElementFields = {
  group: ELEMENT_GROUPS.OTHER,
  label: 'Star Rating',
  icon: 'DocumentTextIcon',
  description: 'Adds a star rating',
  properties: [
    'layout',
    'fontFamily',
    'color',
    'font',
    'alignment',
    'margin',
    'padding',
    {
      label: 'On Press Action',
      name: 'action',
      editor: 'dropdown',
      default: '',
      description: 'An action to run when the ratings are changed',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Disable Data Binding',
      name: 'databindingDisabled',
      type: 'boolean',
      description: 'If true, this element will use a fixed value',
      editor: 'switch',
      default: true,
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '!==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the value of this element',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '!==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Static Value',
      name: 'value',
      editor: 'number',
      description: 'The number of active stars to display',
      default: '',
      options: [],
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    }
  ]
};

export default StarRatingElementFields;
